import React, { useState } from 'react';
import { TermsOfServiceModal } from './TermsOfServiceModal';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
import { VEXATIOUS_LABEL, VEXATIOUS_DETAIL } from '../../lib/config/vexatiousClauses';

// Estratto riusabile delle 2 checkbox di accettazione T&C viste in RegisterPage.tsx
// (checkbox esplicita + approvazione specifica clausole vessatorie ex artt. 1341-1342
// c.c.). Copy/stile IDENTICI alla versione italiana di RegisterPage — vedi quel file
// per il testo originale. Solo italiano: usato da InviteAcceptPage, pagina sempre IT.
// NB: la checkbox vessatorie qui è un consenso PRELIMINARE — l'approvazione con
// valore di firma (Cass. 20945/2026) avviene con l'OTP in VerifyEmailPage.
const COPY = {
  acceptTermsPre: 'Ho letto e accetto i',
  termsLink: 'Termini e Condizioni',
  and: 'e la',
  privacyLink: 'Privacy Policy',
  vexatiousLabel: VEXATIOUS_LABEL,
  vexatiousDetailToggle: 'vedi dettaglio',
  vexatiousDetailHide: 'nascondi dettaglio',
  vexatiousDetail: VEXATIOUS_DETAIL,
};

interface LegalAcceptanceCheckboxesProps {
  termsAccepted: boolean;
  vexatiousAccepted: boolean;
  onTermsChange: (checked: boolean) => void;
  onVexatiousChange: (checked: boolean) => void;
  /** Messaggio d'errore da mostrare sotto le checkbox (validazione esterna al componente). */
  error?: string | null;
}

export function LegalAcceptanceCheckboxes({
  termsAccepted,
  vexatiousAccepted,
  onTermsChange,
  onVexatiousChange,
  error,
}: LegalAcceptanceCheckboxesProps) {
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showVexatiousDetail, setShowVexatiousDetail] = useState(false);

  return (
    <>
      <div className="space-y-2.5">
        <label className="flex items-start gap-2.5 cursor-pointer">
          <input
            type="checkbox"
            checked={termsAccepted}
            onChange={(e) => onTermsChange(e.target.checked)}
            className="mt-0.5 h-4 w-4 shrink-0 rounded border-[rgba(55,53,47,0.3)] text-[#2383E2] focus:ring-[#2383E2] cursor-pointer"
          />
          <span className="text-xs text-[#787774] leading-relaxed">
            {COPY.acceptTermsPre}{' '}
            <button
              type="button"
              onClick={(e) => { e.preventDefault(); setShowTermsModal(true); }}
              className="text-[#2383E2] hover:underline"
            >
              {COPY.termsLink}
            </button>{' '}
            {COPY.and}{' '}
            <button
              type="button"
              onClick={(e) => { e.preventDefault(); setShowPrivacyModal(true); }}
              className="text-[#2383E2] hover:underline"
            >
              {COPY.privacyLink}
            </button>
          </span>
        </label>

        <div>
          <label className="flex items-start gap-2.5 cursor-pointer">
            <input
              type="checkbox"
              checked={vexatiousAccepted}
              onChange={(e) => onVexatiousChange(e.target.checked)}
              className="mt-0.5 h-4 w-4 shrink-0 rounded border-[rgba(55,53,47,0.3)] text-[#2383E2] focus:ring-[#2383E2] cursor-pointer"
            />
            <span className="text-xs text-[#787774] leading-relaxed">
              {COPY.vexatiousLabel}{' '}
              (<button
                type="button"
                onClick={(e) => { e.preventDefault(); setShowVexatiousDetail(!showVexatiousDetail); }}
                className="text-[#2383E2] hover:underline"
              >
                {showVexatiousDetail ? COPY.vexatiousDetailHide : COPY.vexatiousDetailToggle}
              </button>)
            </span>
          </label>
          {showVexatiousDetail && (
            <p className="mt-1.5 ml-[26px] text-[11px] text-[#787774] leading-relaxed bg-[rgba(55,53,47,0.03)] border border-[rgba(55,53,47,0.09)] rounded-md px-2.5 py-2">
              {COPY.vexatiousDetail}
            </p>
          )}
        </div>

        {error && (
          <p className="text-xs text-red-600">{error}</p>
        )}
      </div>

      <TermsOfServiceModal
        isOpen={showTermsModal}
        onClose={() => setShowTermsModal(false)}
      />
      <PrivacyPolicyModal
        isOpen={showPrivacyModal}
        onClose={() => setShowPrivacyModal(false)}
      />
    </>
  );
}

export default LegalAcceptanceCheckboxes;
